export default "#version 300 es\n\nprecision mediump float;\n\nin vec3 vCol;\n\nout vec4 fragColor;\n\nvoid main(void) {\n\tfragColor = vec4(vCol,1);\n}";